










































// @ is an alias to /src
import Vue from "vue";
import { FaqRepo, IFaq } from "../libs/FaqRepository";
import Vue2Filters from "vue2-filters";

export default Vue.extend({
  name: "Settings",
  components: {
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      faq: [] as IFaq[],
    };
  },
  methods: {
    redirectCookie : function(){
      this.$router.push('cookiepolicy');
    },
    redirectPrivacy : function(){
      this.$router.push('privacypolicy');
    },
    redirectConditions : function(){
      this.$router.push('conditions');
    }
  },
  created : async function() {
      
  },
  mounted: async function() {
    this.faq = await FaqRepo.getAll();

  },
  watch: {
   
  },
  computed: {
  }
});
